/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_SubmitInputs */

const en_audit_submit = /** @type {(inputs: Audit_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Audit`)
};

const es_audit_submit = /** @type {(inputs: Audit_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar Auditoria`)
};

/**
* | output |
* | --- |
* | "Submit Audit" |
*
* @param {Audit_SubmitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_submit = /** @type {((inputs?: Audit_SubmitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_SubmitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_submit(inputs)
	return es_audit_submit(inputs)
});